'use client';

import { appendShareParams } from '@repo/config';
import { Container } from '@repo/web-chrome/components/container';
import { useState } from 'react';
import { BsLink45Deg, BsTelegram, BsWhatsapp } from 'react-icons/bs';

interface IExamShareStrings {
  label: string;
  whatsappLabel: string;
  telegramLabel: string;
  copyLabel: string;
  copiedLabel: string;
}

interface IExamShareRowProps {
  share: IExamShareStrings;
  shareUrl: string;
}

export function ExamShareRow({ share, shareUrl }: IExamShareRowProps): React.JSX.Element {
  const [copied, setCopied] = useState(false);
  const taggedUrl = appendShareParams(shareUrl, { source: 'web', campaign: 'exam_share' });
  const text = encodeURIComponent(`${share.label}: ${taggedUrl}`);

  async function onCopy(): Promise<void> {
    if (typeof navigator === 'undefined') {
      return;
    }
    try {
      await navigator.clipboard.writeText(taggedUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  }

  return (
    <Container className="py-12">
      <div
        data-reveal="up"
        className="flex flex-col items-start gap-4 rounded-2xl bg-card p-6 ring-1 ring-foreground/10 sm:flex-row sm:items-center sm:justify-between"
      >
        <p className="text-sm font-medium text-foreground">{share.label}</p>
        <div className="flex flex-wrap gap-2">
          <a
            href={`https://wa.me/?text=${text}`}
            target="_blank"
            rel="noopener noreferrer"
            className="cm-press inline-flex items-center gap-2 rounded-xl bg-muted px-4 py-2 text-sm font-medium text-foreground hover:bg-accent"
          >
            <BsWhatsapp aria-hidden /> {share.whatsappLabel}
          </a>
          <a
            href={`https://t.me/share/url?url=${encodeURIComponent(taggedUrl)}&text=${text}`}
            target="_blank"
            rel="noopener noreferrer"
            className="cm-press inline-flex items-center gap-2 rounded-xl bg-muted px-4 py-2 text-sm font-medium text-foreground hover:bg-accent"
          >
            <BsTelegram aria-hidden /> {share.telegramLabel}
          </a>
          <button
            type="button"
            onClick={onCopy}
            className="cm-press inline-flex items-center gap-2 rounded-xl bg-muted px-4 py-2 text-sm font-medium text-foreground hover:bg-accent"
          >
            <BsLink45Deg aria-hidden /> {copied ? share.copiedLabel : share.copyLabel}
          </button>
        </div>
      </div>
    </Container>
  );
}
